import gql from 'graphql-tag';

export const REGIST_COMPANION = gql`
    mutation(
        $CompanionList: [CompanionList]
    ){
        RegistCompanion(
            RegistCompanionList: $CompanionList
        ){
            result
        }
    }
`;

export const GET_COMPANION_LIST = gql`
    query(
        $cell_id: String
        $reserve_no: String
        ){
        GetCompanionListFromAdmin(
            cell_id: $cell_id
            reserve_no: $reserve_no
            ){
            CompanionLists{
                reserve_no
                class_no
                player_no
                cell_id
                member_no
                family_name
                given_name
                email
                mobile_number
                gender
                era
                score_level
                profile
                enthusiasm
                nickname
                member_class
                visited_code
                player_num
            }
            ClassList{
                course_name
                play_start
                class_no
                cell_id
                play_number
                cell_play_number
                send_play_together_email_flag
            }
        }
    }
`;

export const GET_RESERVE_INFO = gql`
    query(
        $reserve_no: String
        ){
        GetReserveInfo(reserve_no: $reserve_no)
        {
            ReserveInfoList{
                course_name
                play_start
                play_number
                cell_id
                cell_play_number
                send_play_together_email_flag
            }
        }
    }
`;

// プラン詳細確認
export const GET_PLAN_DETAILED = gql`
  query(
      $plan_id: Int
      $cell_id: Int
  ) {
    GetPlanDetailedConfirmation(
        plan_id: $plan_id
        cell_id: $cell_id
    ) {
        PlanDetailsList {
        total_fee
        plan_name
        golf_code
        golf_name
        play_date
        play_start
        round_code
        cart_code
        request_flag
        add_fee_2b_weekday
        add_fee_3b_weekday
        add_fee_2b_weekend
        add_fee_3b_weekend
        guarantee_code
        caddie_flag
        lesson_flag
        meal_flag
        accommodation_flag
        benefit_flag
        course_name
        cancel_detail
        detail
      }
    }
  }
`;

export const UPDATE_COMPANION = gql`
    mutation(
        $CompanionList: [CompanionList]
        $ReserveNumbers: [ReserveNumbers]
    ){
        UpdateCompanionFromAdmin(
            UpdateCompanionList: $CompanionList
            ReserveNumbersList: $ReserveNumbers
        ){
            result
        }
    }
`;

export const GET_RESERVE_COMPANION = gql`
    query(
            $reserve_no: String
        ){
            GetReserveCompanionFromAdmin(reserve_no: $reserve_no)
        {
            ReserveCompanions{
                reserve_no
                member_no
                cell_number
                play_number
                reserve_type
                send_play_together_email_flag
                cell_id
                cell_player_number
                course_code
                course_name
                play_date
                play_start
                player_left
                plt_reserve_no
                class_no
                player_no
                plt_member_no
                family_name
                given_name
                gender
                email
                mobile_number
                era
                score_level
                profile
                enthusiasm
                nickname
                member_class
                visited_code
                player_min
                player_max
                plan_id
            }
        }
    }
`;
